import type {InvoiceDraft} from './types';
import {InvoiceActionType} from './types';

const updateInvoiceReducer = (
  state: InvoiceDraft,
  action: {type: InvoiceActionType; payload: Partial<InvoiceDraft>},
): InvoiceDraft => {
  switch (action.type) {
    case InvoiceActionType.UPDATE_INVOICE:
      return {...state, ...action.payload};

    // Replaces rather than merges, so reopening the form cannot leave a value
    // behind from the previous invoice.
    case InvoiceActionType.RESET_INVOICE:
      return {...action.payload} as InvoiceDraft;

    default:
      return state;
  }
};

export default updateInvoiceReducer;
